<template>
  <div class="table">
    <p>全部格式或版本：</p>
    <el-table
      :data="tableData"
      :row-class-name="rowClassName"
      :header-cell-style="{
        'text-align': 'center',
        background: '#F0F0F0',
        color: '#333',
      }"
      :cell-style="{ 'text-align': 'center' }"
      header-align="center"
    >
      <el-table-column label="载体类型及描述">
        <template slot-scope="scope">
          <p>
            <img
              class="mark"
              v-if="$methods.isLibrary(scope.row.libraryCustomerCode)"
              :src="iconGc"
            />
            <span>{{ getBookType(scope.row.type) }}</span>
            <span v-if="scope.row.typeInfo">({{ scope.row.typeInfo }})</span>
          </p>
        </template>
      </el-table-column>
      <el-table-column property="editionStr" label="版本版次装帧卷册供货商">
        <template slot-scope="scope">
          <p>
            <span v-if="scope.row.versionStr">
              {{ scope.row.versionStr }}
              <template
                v-if="scope.row.editionStr || scope.row.binding || scope.row.volumeNo"
              >
                ,
              </template>
            </span>
            <span v-if="scope.row.editionStr">
              {{ scope.row.editionStr }}
              <template v-if="scope.row.binding || scope.row.volumeNo">,</template>
            </span>
            <span v-if="scope.row.binding">
              {{ scope.row.binding }}
              <template v-if="scope.row.volumeNo">,</template>
            </span>
            <span v-if="scope.row.volumeNo">{{ scope.row.volumeNo }}</span>
          </p>
        </template>
      </el-table-column>
      <el-table-column property="isbn" label="ISBN">
        <template slot-scope="scope">
          <p class="isbn" @click="toDetail(scope.row)">
            <a>{{ scope.row.isbn }}</a>
          </p>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            class="text-button"
            type="text"
            @click="buttonClick(scope.row, 1)"
            v-if="buttonText2(scope.row, 1)"
          >
            {{ buttonText2(scope.row, 1) }}
          </el-button>
          <el-button
            class="text-button"
            type="text"
            @click="handleRecommendClick(scope.row)"
            :disabled="alreadyRecommended(scope.row)"
          >
            {{ alreadyRecommended(scope.row) ? '已推荐' : '推荐' }}
          </el-button>
          <el-button
            class="text-button"
            type="text"
            @click="handleFavoriteClick(scope.row)"
            :disabled="alreadyFavorite(scope.row)"
          >
            {{ alreadyFavorite(scope.row) ? '已收藏' : '收藏' }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <RecommendDialog
      :book="dialogBook"
      :showDialog="showRecommend"
      @close="showRecommend = false"
    />
    <FavoriteDialog
      :showDialog="showFavorite"
      :book="dialogBook"
      @save-list="afterFavorite"
      @close-export="showFavorite = false"
    />
  </div>
</template>

<script>
import tableMixin from '@/mixins/table.js'
import favoriteMixin from '@/mixins/favorite'
import RecommendDialog from '../../components/RecommendDialog.vue'
import FavoriteDialog from '../list/FavoriteDialog.vue'

export default {
  name: 'BookDetailTable',
  mixins: [tableMixin, favoriteMixin],
  props: {
    tableData: Array,
  },
  data() {
    return {
      iconGc: require('images/icon-gc.png'),
    }
  },
  watch: {
    $route(newVal, oldVal) {
      if (newVal.query.id !== oldVal.query.id) {
        location.reload()
      }
    },
  },
  methods: {
    priceWithCents(item) {
      const price = item.price
      if (!price) {
        return ''
      } else if (price % 1 === 0) {
        return price + '.00'
      } else {
        return price.toFixed(2)
      }
    },
    isbnLink(row) {
      this.$router.push({
        path: '/BookDetail',
        query: { id: row.ruid },
      })
    },
    rowClassName({ row }) {
      if (row.ruid == this.$route.query.id) {
        return 'active-row'
      }
    },
  },
  mounted() {
    console.log(this.tableData)
  },
  components: { RecommendDialog, FavoriteDialog },
}
</script>

<style lang="scss" scoped>
a {
  color: #2f8bd6;
  text-decoration: underline;
  cursor: pointer;
}
/deep/ .el-table {
  border: 1px solid #ebeef5;
  border-bottom: none;
}
/deep/ .el-table__body,
/deep/ .el-table__header {
  .cell {
    font-weight: normal !important;
    font-size: 16px !important;
    color: #666 !important;
  }
}
.alink {
  color: #5689ca;
  cursor: pointer;
  text-decoration: underline;
}
.scopeImg {
  margin: 0 auto;
  width: 100px;
  height: 100px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid #cccccc;
  img {
    max-width: 98px;
    max-height: 98px;
  }
}
.table {
  margin-top: 20px;
  font-size: 16px;
  color: #666;
  .el-table {
    margin-top: 10px;
    /deep/ .el-table__header,
    /deep/ .el-table__body {
      width: 100% !important;
    }
    /deep/ .cell {
      font-weight: normal !important;
      font-size: 16px;
    }
    /deep/ thead tr {
      background-color: #eee;
      .el-table__cell {
        padding: 9px;
        background-color: transparent;
        color: #999;
        font-size: 16px;
      }
    }
    /deep/ tbody {
      .active-row {
        background-color: #eaf3fb !important;
        td:first-child::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 30px 30px 0 0;
          border-color: #2f8bd6 transparent transparent transparent;
        }
      }
      .el-table__cell {
        color: #666;
      }
      .price {
        color: #f00;
      }
    }
    /deep/ th {
      padding: 5px 0;
    }
    /deep/ td {
      padding: 5px 0;
    }
  }
}
.mark {
  margin-right: 20px;
}
.text-button {
  font-size: 16px;
}
</style>
